export const navBarTabNames = {
    samples: 'Probendaten',
    login: 'Anmelden'
};
